import { useState, useEffect } from "react";
import { useIsMounted } from "./useIsMounted";
const LABEL_FIELD_NAME = "name";
export const useFieldLookup = (dataGetter, id) => {
    const [label, setLabel] = useState("");
    const isMountedRef = useIsMounted();
    useEffect(() => {
        const isNonEmptyId = id !== undefined && id !== null && id !== "";
        if (isNonEmptyId) {
            dataGetter
                .get(id)
                .then(item => {
                const lookupValue = (item === null || item === void 0 ? void 0 : item[LABEL_FIELD_NAME]) || id; // fallback to showing the id if something is wrong
                if (isMountedRef.current) {
                    setLabel(lookupValue);
                }
                else {
                    console.warn("NOT MOUNTED", id, lookupValue);
                }
            })
                .catch(err => {
                if (isMountedRef.current) {
                    setLabel(id); // fallback to showing the id if something is wrong
                }
                console.warn("useFieldLookup error", id, err);
            });
        }
    }, [dataGetter, id, isMountedRef]);
    return label;
};
